module.exports = __webpack_public_path__ + "img/shushuai1.45870e1a.png";